<template>
    <modal
        class="is-narrow"
        v-bind:title="__('Edit campaign')"
        v-bind:is-open="isOpenEditModal"
        v-on:close-modal="close"
        v-bind:slot-props="errors"
        v-bind:key="key"
    >
        <template v-slot:body>
            <div class="has-margin-b30">
                <control
                    label-field="name"
                    name="userAddControl"
                    type="autocomplete"
                    v-bind:label="__('User')"
                    v-bind:source-search="getUsers"
                    v-if="userObject"
                    v-model="userObject"
                />
                <div
                    class="has-text-danger has-margin-b10"
                    v-if="errors.user_id != null"
                >
                    {{ errors.user_id[0] }}
                </div>
            </div>
            <div class="has-margin-b30">
                <control
                    label-field="title"
                    name="programAddControl"
                    type="autocomplete"
                    v-bind:label="__('Program')"
                    v-bind:source-search="getPrograms"
                    v-if="program"
                    v-model="program"
                />
                <div
                    class="has-text-danger has-margin-b10"
                    v-if="errors.program_id != null"
                >
                    {{ errors.program_id[0] }}
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <btn
                class="is-block is-success"
                type="default"
                v-html="__('Save')"
                v-on:click="updateCampaign"
            ></btn>
        </template>
    </modal>
</template>

<script>
import ProgramRepository from '../../../repositories/ProgramRepository';
import userConfig from '../../../config/userConfig';
import UserRepository from '../../../repositories/UserRepository';
import { Btn, Control, Modal } from '@teamfurther/cinderblock';

export default {
    components: {
        Btn,
        Control,
        Modal
    },
    data: function() {
        return {
            key: 0,
            program: null,
            programRepository: new ProgramRepository(),
            userObject: null,
            userRepository: new UserRepository()
        };
    },
    methods: {
        close: function() {
            this.$emit('close');
        },
        getPrograms: async function(searchString) {
            try {
                return await this.programRepository.getProgramsFilteredByTitle(
                    searchString
                );
            } catch (e) {}

            return [];
        },
        getUsers: async function(searchString) {
            try {
                return await this.userRepository.getUsersFilteredByNameAndRole(
                    searchString,
                    userConfig.roles.user
                );
            } catch (e) {}

            return [];
        },
        updateCampaign: function() {
            this.$emit('update', {
                id: this.campaign.id,
                programId: this.program.id,
                userId: this.userObject.id
            });
        }
    },
    props: {
        campaign: {
            required: true,
            type: Object
        },
        errors: {
            required: true,
            type: Object
        },
        isOpenEditModal: {
            required: true,
            type: Boolean
        }
    },
    watch: {
        campaign: function() {
            this.program = this.campaign.program;
            this.userObject = this.campaign.user;

            this.key++;
        }
    }
};
</script>
